import { useFormContext } from "react-hook-form";
import { FacilitiesData, Membership } from "@/types/system-setting/membership";
import { useEffect, useState } from "react";
import FacilityTableView from "./table";
import { Card } from "@/components/ui/card";

const FacilityDetailsForm = () => {
  const [facilites, setFacilities] = useState<FacilitiesData[]>([])

  const {
    setValue,
  } = useFormContext<Membership>();

  useEffect(() => {
    if (facilites) {
      setValue("facilities", facilites)
    }
  }, [facilites])

  return (
    <div className="text-black space-y-4">
      <Card className="p-4">
        <FacilityTableView setFacilities={setFacilities} />
      </Card>
    </div>
  );
};

export default FacilityDetailsForm;